











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {Rastreamento} from '@/model/resource/Rastreamento'
import {RastreamentoCollection} from '@/model/collection/RastreamentoCollection'
import {ListRastreamentoSchema} from '@/schema/resource/Rastreamento/ListRastreamentoSchema'
import {CsvRastreamentoSchema} from '@/schema/resource/Rastreamento/CsvRastreamentoSchema'

@Component
export default class ListRastreamentoView extends Mixins(MixinQueryRouter) {
  schema = new ListRastreamentoSchema()
  collection = new RastreamentoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: Rastreamento) {
    Helper.pushByName('editRastreamento', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new RastreamentoCollection().clearFilters().addFilter(params)

    await csv.listCsvRastreamento()
    new CsvRastreamentoSchema().downloadCsv(csv.all())
  }
}
